<script setup>
import { ref } from 'vue';

defineProps({
    modelValue: [String, Number],
    placeholder: String,
    nullValue: {
        type: Boolean,
        default: false,
    },
    options: Array,
    hasError: Boolean,
});

defineEmits(['update:modelValue']);

const select = ref(null);
</script>

<template>
    <select
        ref="select"
        class="form-select focus:border-deep-teal-600 focus:ring-1 focus:ring-deep-teal-600 rounded-md"
        :class="hasError ? 'text-red-900 border-red-600' : 'border-gray-300'"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    >
        <option
            v-if="placeholder"
            disabled
            v-text="placeholder"
        />

        <option
            v-if="nullValue"
            value=""
            v-text="'-'"
        />

        <option
            v-for="option in options"
            :key="option.value"
            :value="option.value"
            v-text="option.text"
        />
    </select>
</template>
